import React, { useEffect, useState } from "react";
import "./styles.scss";
import { ReactComponent as Backbtn } from "../../assets/icons/backbtn.svg";

import Question from "./question";
import ProgressBar from "../../common/progressBar";
import { useNavigate, useParams } from "react-router-dom";
import { useStateValue } from "../../store";
import { getAssessmentData } from "../../store/homeAction/action";

const Assessment = ({ data }) => {
  const Navigate = useNavigate();
  const { question } = useParams();
  const [{}, dispatch] = useStateValue();
  const [qtnValue, setQtnValue] = useState([
    JSON.parse(sessionStorage.getItem("qtnValues"))?.question,
  ]);
  useEffect(() => {
    if (Object.keys(data).length == 0) {
      getAssessmentData((res, error) => {
        dispatch({
          type: "SET_ASSESSMENT_LANDING",
          data: res,
        });
        if (error) {
          dispatch({
            type: "SET_ALERT_MESSAGE",
            value: true,
            data: {
              severity: "error",
              message: "Something went wrong, Please try again.",
            },
          });
        }
      });
    }
  }, []);

  const temp = question.split("_").pop();
  const filteredData =
    qtnValue !== undefined && qtnValue[temp] !== undefined && qtnValue[temp];
  return (
    <div className="assessment-container">
      {Object.keys(data).length !== 0 ? (
        <>
          <Backbtn onClick={() => Navigate(-1)} />
          <div className="sub-container">
            <h3>Answer the following questions</h3>
          </div>
          <div className="question-title">
            <span className="text">
              Question {question.split("_").pop()} of{" "}
              {data?.question_answers?.length}
            </span>
            <ProgressBar
              timestamp={
                (parseInt(question.split("_").pop()) /
                  data?.question_answers?.length) *
                100
              }
            />
          </div>
          <Question
            qtnValue={filteredData}
            setQtnValue={setQtnValue}
            questionNumber={question.split("_").pop()}
            question={data?.question_answers?.filter(
              (_, index) => index == parseInt(question.split("_").pop()) - 1
            )}
            length={data?.question_answers?.length}
          />
        </>
      ) : null}
    </div>
  );
};

export default Assessment;
